import './Error.css'

export default function Error () {
  return <div class='Error'>Error</div>
}
